export type OptionsType = {
  label: string
  value: string
}

export const isCommercialLease = (purposeType: string) => purposeType === 'Commercial Lease'